import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import TranslatableParagraph from '../translatable_paragraph/translatable_paragraph'
import StringHelper from '../../helpers/string_helper'
import Rating from './rating'
import moment from 'moment'
import './review.scss'
import { Trans, withNamespaces } from "react-i18next"
import { compose } from 'redux'

class Review extends React.Component {
  get referenceCode() {
    return this.props.review.reservation.reference_code
  }

  get reviewPath() {
    return routeUrlHelper.reviewPath('me', this.referenceCode)
  }

  get travelPath() {
    return routeUrlHelper.travelPath(this.props.reservation.id)
  }

  get listingTitle() {
    const { room_group: { room_title: roomTitle } = {} } = this.props.reservation
    return StringHelper.getPreferredLanguageString(roomTitle || {}, languageHelper.pageLocale)
  }

  render() {
    const {
      overall,
      cleanliness,
      facilities,
      location,
      safety,
      comment,
      updatable_until: updatableUntil,
      completed_at: completedAt
    } = this.props.review
    const { t } = this.props

    return (
      <div className="ui-review" styleName="ui-review" itemProp="review" itemScope itemType="http://schema.org/Review">
        { this.props.roomGroup.id &&
          <h3 itemProp="name">
            <Trans i18nKey='users.edit.review.review_to' values={{title: this.listingTitle}}>
              <a href={this.travelPath} className="notranslate">{this.listingTitle}</a>
              へのレビュー
            </Trans>
          </h3>
        }
        <div styleName="overall">
          { this.props.guestUser &&
            <div styleName="guest-info">
              <div styleName="guest-img-wrapper">
                <img styleName="guest-img" src={this.props.guestUser.photo_url || '/assets/image/common/no_image.png'} alt="" />
              </div>
              { this.props.guestUser.nickname && <div styleName="nickname" itemProp="author">{this.props.guestUser.nickname}</div> }
            </div>
          }
          <Rating aspect="overall" value={overall} showValueLabel={true} t={this.props.t} />
        </div>
        <div styleName="comment">
          <TranslatableParagraph content={comment} enabled={this.props.translationEnabled} itemProp="reviewBody" />
        </div>
        <div styleName="aspects">
          <Rating aspect="cleanliness" value={cleanliness} aspectLabel={t('users.edit.review.cleanliness')} />
          <Rating aspect="facilities" value={facilities} aspectLabel={t('users.edit.review.facilities')} />
          <Rating aspect="location" value={location} aspectLabel={t('users.edit.review.location')} />
          <Rating aspect="safety" value={safety} aspectLabel={t('users.edit.review.safety')} />
          <meta itemProp="datePublished" content={moment(completedAt).format('YYYY-MM-DD')} />
          <div styleName="footer">
            <dl className="completed-at" styleName="completed-at">
              <dt>{t('users.edit.review.post_date')}</dt><dd><time dateTime={moment(completedAt).format('YYYY-MM-DD')} itemProp="datePublished">{moment(completedAt).format('LL')}</time></dd>
            </dl>
            { this.props.onClick && new Date(updatableUntil) > new Date() &&
              <div styleName="edit">
                <time className="vs-icon vs-icon-clock" dateTime={updatableUntil}>{moment(updatableUntil).format('LLL')}</time>{t('users.edit.review.until')}
                <Link className="btn btn-sm btn-outlined" to={this.reviewPath} onClick={() => this.props.onClick(this.props.review)}>{t('users.edit.review.update')}</Link>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }

  static propTypes = {
    lang: PropTypes.string,
    reservation: PropTypes.object,
    roomGroup: PropTypes.object,
    review: PropTypes.object.isRequired,
    guestUser: PropTypes.object,
    onClick: PropTypes.func,
    translationEnabled: PropTypes.bool
  }

  static defaultProps = {
    lang: '',
    reservation: {},
    roomGroup: {},
    guestUser: null,
    review: {},
    translationEnabled: false
  }
}

export default compose( withNamespaces('users') )(Review)
